module.exports = __webpack_public_path__ + "assets/img/2213.70036543.png";